/**
 * Wraps asterisks at start of text node or end of text node, including wrapped in HTML tags in aria-hidden span
 * @param inputText
 */
export default function ariaHideAsterisks(inputText = '') {
  return inputText.replace(
    /(?:^\s*\*+)|(>\s*)(\*+)|\*+(?=\s*(?:<!--.*?-->)?\s*<\/)/g,
    (match, prefix, asterisks) =>
      `${prefix || ''}<span aria-hidden="true">${
        prefix ? asterisks : match
      }</span>`
  )
}
